import { render, staticRenderFns } from "./WatcherBadge.vue?vue&type=template&id=62569d7e&"
import script from "./WatcherBadge.vue?vue&type=script&lang=ts&"
export * from "./WatcherBadge.vue?vue&type=script&lang=ts&"
import style0 from "./WatcherBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports